<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<!--information about the report -->
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`"/>
            </v-row>
			
			<!--table head-->
			<v-divider color="black" />
			<v-row class="subtitle-2" no-gutters>
				<v-col v-for="item in headers" :key="item.title"
					class="text-pre-wrap"
					:class="item.style">
					{{ `${item.title}` | localize }}
				</v-col>
			</v-row>
			<v-divider color="black" />
			<!--table content-->
			<div v-if="products?.length">
				<div v-for="item in modelsByTrademark" :key="item.trademarkId">
					<!-- trademark-->
					
					<div class="body-2 text-pre-wrap secondary--text text-left">
						{{ item.trademark }} ({{ item.team }})
					</div>
					
					<div v-for="product in item.models" :key="product.id">
						<v-row class="body-2 my-1" no-gutters>
							<v-col class="text-left">{{ product.model }}</v-col>
							<v-col class="text-right">{{ product.retail_price }}</v-col>
							<v-col class="text-center">{{ product.design_type }}</v-col>
							<v-col class="text-right">{{ product.design }}</v-col>
							<v-col class="text-right">{{ product.material }}</v-col>
							<v-col class="text-right">{{ product.manufacturing }}</v-col>
							<v-col class="text-right">{{ product.variations }}</v-col>
							<v-col class="text-center">{{ product.advanced_feature }}</v-col>
							<v-col class="text-right">{{ formatNumber(getProductUnits(product)) }}</v-col>
						</v-row>
						<v-divider />
					</div>
				</div>
			</div>
			<v-row v-else justify="center" class="body-2 mt-8">
				<strong>There are no products yet</strong>
			</v-row>
		</div>
		<!-- Loader -->
		<v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
	</v-container>
</template>
<script>
import { localeNumber } from '../../../functions/common';
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';
	export default {
		data (){
			return {
				headers: [
					{style: 'text-left', title: 'Trademark (Team) \n models'},
					{style: 'text-right', title: 'Retail price $'}, 
					{style: 'text-center', title: 'Type of design'}, 
					{style: 'text-right', title: 'Design level'}, 
					{style: 'text-right', title: 'Material level'}, 
					{style: 'text-right', title: 'Manufacturing level'}, 
					{style: 'text-right', title: 'Variations'}, 
					{style: 'text-center', title: 'Functional expansion'}, 
					{style: 'text-right', title: 'Sales last year (units)'}],
				tab: 0,
				isLoaded: false,
				text: {
					en: 'The product report provides an overview of the products currently available on the market and includes estimated sales volumes for each.',
					ro: 'Raportul privind produsele oferă o imagine de ansamblu asupra produselor disponibile în prezent pe piață și include estimări privind volumul vânzărilor pentru fiecare dintre acestea.',
					ru: 'В отчете о продукции представлен обзор товаров, доступных в настоящее время на рынке, а также приведены прогнозные объемы продаж по каждому из них.'
				}
				
			}
		},		
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			products() {
				return this.$store.getters.products_all;
			},
			sales() {
				return this.$store.getters.sales;
			},
			modelsByTrademark() {
				const trademarks = [];
				if (this.products?.length > 0) {
					let team = this.products[0].team.name.split('_')[0];
					trademarks.push(
						{
							trademarkId: this.products[0].trademarkId,
							trademark: this.products[0].trademark.name,
							team: team,
							models: [this.products[0]]
						}
					)
					for (let i = 1; i < this.products?.length; i++) {
						const inArr = trademarks.find(tr => tr.trademarkId === this.products[i].trademarkId)
						if (inArr) {
							inArr.models.push(this.products[i]);
						}
						else {
							team = this.products[i].team.name.split('_')[0];
							trademarks.push(
								{
									trademarkId: this.products[i].trademarkId,
									trademark: this.products[i].trademark.name,
									team: team,
									models: [this.products[i]]
								}
							)
						}
					}
				}
				return trademarks;
			},
		},
		methods: {
			formatNumber(num) {
				let res = 0;
				if (num) {
					res = localeNumber(num, this.locale);
				}
				return res;
			},
			getProductSales(product) {
				let result = 0;
				if (this.sales?.length > 0) {
					const matched = this.sales.find((item) => item.productId == product.productId);
				if (matched) {
					result = matched.sales;
				}
				}
				return result;
			},
			getProductUnits(product) {
				let result = 0;
				if (this.sales?.length > 0) {
					const matched = this.sales.find((item) => item.productId == product.productId);
					if (matched) {
						result = matched.sales_units;
					}
				}
				return result;
			},
			TotalUnits(models) {
				let res = 0;
				if (models?.length > 0) {
					res = models.reduce((sum, model) => {
						const matched = this.sales?.find((item) => item.productId == model.productId);
						if (matched) {
							return (sum+= matched.sales_units);
						}
					}, 0);
				}
				
				return res;
			},
			TotalSales(models) {
				let res = 0;
				if (models?.length > 0) {
					res = models.reduce((sum, model) => {
					const matched = this.sales?.find((item) => item.productId == model.productId);
					if (matched) {
						return (sum += matched.sales_units);
					}
				}, 0);
				}
				return res;
			}
		},
		components: { Information, Loader },
		async created() {

			if (this.game && this.game.round > 0) {
				const obj = {
					gameId: this.game.id,
					round: this.game.round - 1
				}

				if (this.products?.length < 1 ) {
					try {
						//get allProducts
						await this.$store.dispatch('fetchProducts', obj);
					} catch (error) { 
						await this.$store.dispatch('setError', error.message);
					}
				}
								
				if (this.sales?.length < 1) {
					try {
						//get allSales
						await this.$store.dispatch('fetchSales', obj);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}
			}
			this.isLoaded = true;
		}
	}
</script>